// La barra de arriba de un SlidePanel se viste como la TopNav: de borde a borde
// y pintando también la franja de la barra de estado del teléfono. Con el fondo
// del cuerpo se leía como una caja oscura suelta. La usan la barra de título de
// SlidePanel y el bloque de identidad de DetailPanel, que hace de barra cuando
// no hay título. Módulo aparte para que los `vi.mock` de SlidePanel no la pierdan.
export const PANEL_BAR = "bg-background-elevated sheen-chrome border-b border-border-muted";
